var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('map-home-small',{ref:"maphomes",attrs:{"qipao":_vm.qipao,"luxian":_vm.luxian,"coord":_vm.coord,"clockId":_vm.clockId,"dataList":_vm.list,"lineList":_vm.lineList},on:{"markclick":(e)=>{_vm.$emit('markclick',e)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }